import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
import { useTheme } from '../ThemeContext.tsx';
import { ProgressBarProps } from './chat/WelcomeScreen/types';

const pillars = [
    {
        id: 'distribution',
        label: 'Distribution Power',
    },
    {
        id: 'transaction',
        label: 'Transaction Capture',
    },
    {
        id: 'execution',
        label: 'Execution Excellence',
    },
    {
        id: 'loyalty',
        label: 'Customer Loyalty',
    }
];

const ProgressBar: React.FC<ProgressBarProps> = ({ activePillar, onPillarSelect }) => {
    const { colors } = useTheme();

    // Find the index of active pillar for progress bar calculation
    const activeIndex = pillars.findIndex(p => p.id === activePillar);

    return (
        <div className="w-full max-w-4xl mx-auto my-1">
            {/* Hint text for first-time users */}
            <p className={`text-xs text-center mb-2 ${colors.text.tertiary}`}>
                Click on each section below to explore different question categories
            </p>

            <div className="relative">
                {/* Progress bar with segments */}
                <div className={`relative h-3 rounded-full overflow-hidden ${colors.bg.tertiary} flex`}>
                    {pillars.map((pillar, index) => {
                        const isActive = pillar.id === activePillar;
                        return (
                            <div
                                key={pillar.id}
                                className={`
                                    flex-1 h-full transition-colors duration-300
                                    ${isActive ? 'bg-[#13670B]' : ''}
                                    ${index < pillars.length - 1 ? 'border-r border-white/20' : ''}
                                `}
                            />
                        );
                    })}
                </div>

                {/* Pillar labels */}
                <div className="flex justify-between mt-2">
                    {pillars.map((pillar) => {
                        const isActive = pillar.id === activePillar;

                        return (
                            <button
                                key={pillar.id}
                                onClick={() => onPillarSelect(pillar.id)}
                                className="flex flex-col items-center gap-0.5 relative focus:outline-none cursor-pointer group"
                            >
                                {/* Icon - CheckCircle for active, Circle for inactive */}
                                <div>
                                    {isActive ? (
                                        <CheckCircle2
                                            size={20}
                                            className="text-[#13670B] transition-colors duration-200"
                                        />
                                    ) : (
                                        <Circle
                                            size={20}
                                            className="text-gray-400 group-hover:text-[#13670B]"
                                        />
                                    )}
                                </div>

                                {/* Label */}
                                <span className={`
                                    text-xs font-semibold text-center max-w-[150px] 
                                    duration-200
                                    ${isActive
                                        ? 'text-[#13670B]'
                                        : 'text-gray-400'
                                    }
                                `}>
                                    {pillar.label}
                                </span>

                                {/* Active indicator - underline bar */}
                                {/* <div className={`
                                    absolute -bottom-1 left-1/2 -translate-x-1/2 
                                    h-0.5 rounded-full bg-[#13670B]/60
                                    transition-all duration-200
                                    ${isActive ? 'w-3/4 opacity-100' : 'w-0 opacity-0'}
                                `} /> */}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;
